import { EmailTemplateCreateMethodTypes } from "@enums/email-template-create-method-types";
import { SelectOption } from "@idw-types/common";

export const EMAIL_TEMPLATE_CREATE_METHOD_OPTIONS: Array<SelectOption<EmailTemplateCreateMethodTypes>> = [
    {
        label: "create a email template from scratch",
        value: EmailTemplateCreateMethodTypes.CREATE_FROM_SCRATCH
    },
    {
        label: "Create a new email template using an existing template as the starting point",
        value: EmailTemplateCreateMethodTypes.USE_TEMPLATE
    }
];